import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156f2d28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "subtitle"
}

import { withDefaults, watch, ref } from 'vue';
import { AtomSelect } from '@/components/atoms';
import * as comps from '@/components/atoms';
import { IOptionsSelect } from '@/types';

interface IProps {
  title: string;
  subtitle?: string;
  label?: string;
  loading?: boolean;
  textTooltip?: string;
  icon?: string;
  iconColor?: string;
  iconBgColor?: string;
  hasDropdownList?: boolean;
  hasTabs?: boolean;
  footer?: boolean;
  optionsDropDown?: IOptionsSelect[];
  isCalendarSelect?: boolean;
  isOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCardAccordion',
  props: {
    title: {},
    subtitle: {},
    label: {},
    loading: { type: Boolean, default: false },
    textTooltip: {},
    icon: {},
    iconColor: {},
    iconBgColor: {},
    hasDropdownList: { type: Boolean },
    hasTabs: { type: Boolean, default: false },
    footer: { type: Boolean },
    optionsDropDown: {},
    isCalendarSelect: { type: Boolean, default: false },
    isOpen: { type: Boolean, default: true }
  },
  emits: ['onChangeDropDownList'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
function handleChangeDropdownList(event) {
  emit('onChangeDropDownList', event);
}
const panels = ref<any>();
watch(() => props.isOpen, () => {
  panels.value = props.isOpen ? [0] : undefined
})

return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createBlock(_component_v_expansion_panels, {
    class: "accordion-card border",
    modelValue: panels.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((panels).value = $event)),
    mandatory: _ctx.isOpen ? 'force' : false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_expansion_panel, { value: "open" }, {
        title: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex align-center header-card", { 'justify-space-between': !props.hasTabs, 'border-b': props.hasTabs }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              (props.icon)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: _normalizeStyle({ backgroundColor: props.iconBgColor }),
                    class: "pa-2 mr-2 rounded"
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.icon]), {
                      color: props.iconColor
                    }, null, 8, ["color"]))
                  ], 4))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(props.title), 1),
                (props.subtitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.subtitle), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (props.hasDropdownList)
              ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                  key: 0,
                  onOnChangeDropDownList: handleChangeDropdownList,
                  isCalendar: _ctx.isCalendarSelect,
                  options: props.optionsDropDown,
                  label: props.label,
                  class: "m-0"
                }, null, 8, ["isCalendar", "options", "label"]))
              : _createCommentVNode("", true),
            (props.hasTabs)
              ? _renderSlot(_ctx.$slots, "tabs", { key: 1 })
              : _createCommentVNode("", true)
          ], 2)
        ]),
        text: _withCtx(() => [
          (_ctx.$slots.body)
            ? _renderSlot(_ctx.$slots, "body", { key: 0 })
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue", "mandatory"]))
}
}

})